import { Subject } from 'rxjs';

export class ServiceMessage {
    messageSource = new Subject<any>();
    message = this.messageSource.asObservable();
}
